import { HttpService } from '@/infra/http'
import type { TNacionalidade } from '@/types/cliente'

export class GetNacionalidadesService extends HttpService {
  async execute() {
    return this.http.get<TNacionalidade[]>('api/v2/Nacionalidade/lista')
  }
}
